import React, {Component} from 'react';
import {gpn} from "../GPN"
import ModalLoading from "../sections/ModalLoading";
import req from "../req";
import config from "../config";
import Button from "../sections/MUI/Button";
import axios from "axios";
import FileDownload from "js-file-download";

class Profile extends Component {

    state = {
        info: null,
        isValid: "loading"
    };

    componentDidMount() {
        this.props.setTitle("پروفایل");

        this.setState({
            info: this.props.info
        });
        this.checkValidation();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            this.setState({
                info: this.props.info
            });
        }
    }

    downloadValidation() {
        axios.post(`${config.api}/user/validation/download`, "", {
            headers: {
                "authorization": config.token
            },
            responseType: 'blob'
        })
            .then(r => {
                FileDownload(r.data, `${this.props.info.phone}.pdf`);
            })
            .catch(err => {
                console.error(err);
            });
    }

    checkValidation() {
        req.getRequest(`${config.api}/user/validation`)
            .then(r => {
                const {status} = r;
                this.setState({
                    isValid: status === 1 ? "valid" : "invalid"
                });
            })
            .catch(err => {
                this.setState({
                    isValid: "invalid"
                });
            });
    }

    render() {
        let {info, isValid} = this.state;
        return (
            <div className="profile">
                <ModalLoading loading={info === null}/>

                {this.renderProfile()}

                {isValid === "valid" ?
                    <Button icon="download"
                            onClick={() => this.downloadValidation()}>دانلود فایل اعتبارسنجی</Button>
                    : null}
            </div>
        );
    }

    renderProfile() {
        let {info} = this.state;
        if (!info) {
            return null
        } else {
            const {
                fullName,
                nationalCode,
                fatherName,
                birthDate,
                shenasnameh,
                postalCode,
                sokoonat,
                address,
                elatMorajeeh,
                nahveAshnayei,
                signature,
                profilePhoto
            } = info;

            return (
                <>
                    <div className="row">
                        <div className="col-auto">
                            {
                                profilePhoto ? profilePhoto.toString().trim() !== "" ?
                                    <div className="profile-photo">
                                        <img src={`${config.api}/user/profile-photo?token=${config.token}`}
                                             draggable={false}
                                             alt=""/>
                                    </div>
                                    : null : null
                            }

                        </div>
                        <div className="col">
                            <p className="info full-name"><span>نام و نام خانوادگی:</span><span>{fullName}</span></p>
                            <p className="info national-code"><span>کد ملی:</span><span>{nationalCode}</span></p>

                        </div>
                    </div>
                    <p className="info"><span>شماره شناسنامه:</span><span>{shenasnameh}</span></p>
                    <p className="info"><span>نام پدر:</span><span>{fatherName}</span></p>
                    <p className="info"><span>تاریخ تولد:</span><span>{birthDate}</span></p>
                    <p className="info"><span>کد پستی:</span><span>{postalCode}</span></p>
                    <p className="info"><span>وضعت سکونت:</span><span>{sokoonat}</span></p>
                    <p className="info"><span>آدرس:</span><span>{address}</span></p>
                    <p className="info"><span>علت مراجعه:</span><span>{elatMorajeeh}</span></p>
                    <p className="info"><span>نحوه آشنایی با شرکت:</span><span>{nahveAshnayei}</span></p>
                    <div className="image-signature">
                        <p className="title">امضاء</p>
                        <img src={signature} alt=""
                             draggable={false}/>
                    </div>
                </>

            )
        }
    }
}

export default gpn(Profile);